import React from 'react';

const ErrorPage = () => {
    return ( 
        <div className="error">Taka strona nie istnieje</div>
     );
}
 
export default ErrorPage;